export namespace LocalStorage {
  export const KEYS = {
    impersonateIpCountry: "impersonateIpCountry",
    language: "language",
  };
  export function get<ReturnType>(key: string, defaultValue?: ReturnType) {
    return localStorage.getItem(key) ?? defaultValue;
  }

  export function set(key: string, value: string) {
    return localStorage.setItem(key, value);
  }

  export function remove(key: string) {
    return localStorage.removeItem(key);
  }
}
